if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification && typeof cartNotification.setActiveElement === 'function') {
          cartNotification.setActiveElement(this.openedBy);
        }
        if (this.modalContent) this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');

        this.loadProductDocument(productUrl)
          .then((responseHTML) => {
            this.productElement = this.findProductSection(responseHTML);

            if (!this.productElement) {
              window.location.href = productUrl;
              return;
            }

            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient') {
                this.modalContent.classList.add(classApplied);
              }
            });
            this.modalContent.classList.add('section-pdp1-main');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.outerHTML);
            this.bindPdp2Controls();
            this.addCheckoutButton();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      loadProductDocument(productUrl) {
        return fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'))
          .then((doc) => {
            if (doc.querySelector('.pdp2-main, .pdp1-main')) return doc;
            return fetch(this.withView(productUrl, 'pdp-1'))
              .then((response) => response.text())
              .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'));
          });
      }

      withView(url, view) {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('view', view);
        return parsed.toString();
      }

      findProductSection(doc) {
        return doc.querySelector('.pdp2-main, .pdp1-main') || doc.querySelector('section[id^="MainProduct-"]');
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        this.productElement.querySelectorAll('modal-dialog').forEach((modal) => modal.remove());
        this.productElement
          .querySelectorAll(
            '.pdp2-crumb, .pdp-app-blocks, .pdp2-upsell, .pdp2-payments, .pdp2-thumbs, .pdp2-stage-nav, .pdp2-rule:not(.pdp2-rule--thick), .share-button, complementary-products, .product__accordion'
          )
          .forEach((el) => el.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section || this.productElement.dataset.sectionId;
        if (!sectionId) return;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      bindPdp2Controls() {
        const root = this.modalContent.querySelector('.pdp2-main') || this.modalContent;
        const variantInput = root.querySelector('[data-pdp2-variant-id]');
        const priceCurrent = root.querySelector('[data-pdp2-price-current]');
        const unitEl = root.querySelector('[data-pdp2-unit]');
        const qtyInput = root.querySelector('[data-pdp2-qty]');
        const legendQty = root.querySelector('[data-pdp2-legend-qty]');

        root.querySelectorAll('input[name="pdp2-pack"]').forEach((input) => {
          input.addEventListener('change', () => {
            root.querySelectorAll('.pdp2-pack').forEach((el) => el.classList.remove('is-active'));
            input.closest('.pdp2-pack').classList.add('is-active');
            if (variantInput) variantInput.value = input.value;
            if (priceCurrent && input.dataset.price) priceCurrent.textContent = input.dataset.price;
            if (unitEl && input.dataset.unit) unitEl.textContent = input.dataset.unit;
            if (legendQty) {
              const label = input.closest('.pdp2-pack');
              legendQty.textContent = label ? label.textContent.trim() : input.value;
            }
          });
        });

        root.querySelectorAll('input[name="pdp2-pack-qty"]').forEach((input) => {
          input.addEventListener('change', () => {
            root.querySelectorAll('.pdp2-pack').forEach((el) => el.classList.remove('is-active'));
            input.closest('.pdp2-pack').classList.add('is-active');
            if (qtyInput) qtyInput.value = input.value;
            if (legendQty) legendQty.textContent = input.value;
          });
        });

        root.querySelectorAll('[data-pdp2-qty-change]').forEach((btn) => {
          btn.addEventListener('click', () => {
            if (!qtyInput) return;
            const step = parseInt(qtyInput.step || '1', 10);
            const min = parseInt(qtyInput.min || '1', 10);
            const max = qtyInput.max ? parseInt(qtyInput.max, 10) : 99;
            const next = Math.min(
              max,
              Math.max(min, parseInt(qtyInput.value || '1', 10) + parseInt(btn.dataset.pdp2QtyChange, 10) * step)
            );
            qtyInput.value = next;
          });
        });
      }

      addCheckoutButton() {
        const form = this.modalContent.querySelector('form[data-type="add-to-cart-form"]');
        if (!form || this.modalContent.querySelector('[data-qv-checkout]')) return;

        const wrap = form.querySelector('.pdp2-buy') || form;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp2-atc qv-checkout';
        btn.setAttribute('data-qv-checkout', 'true');
        btn.textContent = 'Zur Kasse';
        btn.addEventListener('click', () => {
          const body = new FormData(form);
          btn.disabled = true;
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: body,
          })
            .then((res) => {
              if (!res.ok) throw new Error('add failed');
              window.location.href = window.Shopify.routes.root + 'checkout';
            })
            .catch(() => {
              btn.disabled = false;
            });
        });
        wrap.appendChild(btn);
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product) return;
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
